import { DiagnosisController } from './diagnosis.controller';

export const DiagnosisComponent: ng.IComponentOptions = {
  bindings: {},
  templateUrl: 'diagnosis/views/diagnosis.html',
  controller: DiagnosisController,
};
